import { getStatusLabel } from 'src/utils/helpers/addInstantBidHelper';

interface UploadProgressBarProps {
  status: string;
  progress: number;
  uploadProgress?: number;
}

const mileStones = [
  { label: 'Initiated', value: 0 },
  { label: 'Uploaded', value: 25 },
  { label: 'Processing', value: 50 },
  { label: 'Finalizing', value: 75 },
  { label: 'Completed', value: 100 },
];

const activeStatus = ['uploading', 'pending', 'processing'];

export function UploadProgressBar({ status, progress, uploadProgress }: UploadProgressBarProps) {
  if (!activeStatus.includes(status)) return null;

  const isUploading = status === 'uploading';
  const statusLabel = isUploading
    ? uploadProgress === 100
      ? 'Upload Complete, checking file for issues... '
      : `Uploading ${uploadProgress ?? 0}%`
    : getStatusLabel(status);

  return (
    <div className='progress-wrapper'>
      <div className='progress-header'>
        <span>{statusLabel}</span>
        <span>{Math.floor(progress)}%</span>
      </div>

      <div className='progress-bar'>
        <div className='progress-fill' style={{ width: `${progress}%` }} />
      </div>

      {/* {isUploading && (
        <div className='progress-subtext'>
          Raw upload progress: {Math.floor(uploadProgress ?? 0)}%
        </div>
      )} */}

      <div className='milestones'>
        {mileStones.map(item => {
          const achieved = progress >= item.value;
          return (
            <div key={item.label} className={`milestone-item ${achieved ? 'achieved' : ''}`}>
              <div className='milestone-box'>
                {achieved && <span className='mdi mdi-check' />}
              </div>
              <span className='milestone-label'>{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
